module.exports = __webpack_public_path__ + "static/media/高分三号卫星成像模式和能力表.eaec4b47.png";